import * as React from 'react';

import styles from './styles.module.scss';

export const Badge = (props: { children: any }) => {
    const { children } = props;
    return <div className={styles.badge}>{children}</div>;
};
